app.service('paymentBox', function (loading, console, broker, orderConfig, deliveryLocation, modal, giftCardPaymentType) {
	var $self, $permissions, $paymentType, $proforma, $shopsList, $pesel, $bank, $eTransferBanks, $eTransferShortBank, $cashTerm, config;
	var callbackSuccess;
	var savedPaymentCode, savedBank;
	let isSending = false;

	function refreshShopList() {
		if($shopsList.length){
			deliveryLocation.init({
				deliveryType: 'shop',
				scroll: false
			},function(){
				selectPaymentType(config.paymentCode);			// HAK
			});
		}
	}
	function selectPaymentType(paymentCode, initial) {
		paymentCode = parseInt(paymentCode);
		console.log('WYBÓR PŁATNOŚCI: ' + paymentCode);
		savedPaymentCode = paymentCode;
		if (config.supplementPayment) {
			config.supplementPaymentCode = paymentCode;
		} else {
			config.paymentCode = paymentCode;
		}
		if(paymentCode){
			$paymentType.filter('[value='+paymentCode+']').prop('checked', true);				// czasami w chromie zaznaczana jest inna opcja
		}
		if (paymentCode === 1) {
			$self.addClass('cash');
			$cashTerm.ignore(false);
		} else {
			$self.removeClass('cash');
			$cashTerm.ignore(true);
		}
		if (paymentCode === 2) {
			$self.addClass('transfer');
			$proforma.show();
		} else {
			$proforma.hide();
			$self.removeClass('transfer');
		}
		if (paymentCode === 4) {
			$self.addClass('e-card');
		} else {
			$self.removeClass('e-card');
		}
		if (paymentCode === 5) {
			$self.addClass('show-shops-list instalment');
			if (initial) {
				refreshShopList();
			}
		} else {
			$self.removeClass('show-shops-list instalment');
			$shopsList.empty();
		}
		if (paymentCode === 6) {
			$self.addClass('show-additional-info');
			$pesel.ignore(false);
		} else {
			$self.removeClass('show-additional-info');
			$pesel.ignore(true);
		}
		if (paymentCode === 12) {
			$self.addClass('e-instalment');
		} else {
			$self.removeClass('e-instalment');
		}
		if (paymentCode === 3) {
			$self.addClass('e-transfer');
			$bank.ignore(false);
		} else {
			$self.removeClass('e-transfer');
			$bank.ignore(true);
			if(savedBank){
				if(!$eTransferShortBank.hasClass('short-banks')){
					let $img = $eTransferBanks.filter('[data-id='+savedBank+']').find('img');
					shortPaymentBanks($img);
				}
			}
		}
		if (paymentCode === 14) {
			$self.addClass('master-pass');
		} else {
			$self.removeClass('master-pass');
		}
		if (paymentCode === 16) {
			$self.addClass('gift-card');
		} else {
			$self.removeClass('gift-card');
		}
		if (paymentCode === 19) {
			$self.addClass('blik');
		} else {
			$self.removeClass('blik');
		}
		if (paymentCode === 20) {
			$self.addClass('google-pay');
		} else {
			$self.removeClass('google-pay');
		}
		if (paymentCode === 21) {
			$self.addClass('payu-pay-later');
		} else {
			$self.removeClass('payu-pay-later');
		}
		if (paymentCode === 22) {
			$self.addClass('apple-pay');
		} else {
			$self.removeClass('apple-pay');
		}
		if (paymentCode === 23) {
			$self.addClass('visa-mobile');
		} else {
			$self.removeClass('visa-mobile');
		}
		if (paymentCode === 24) {
			$self.addClass('blik-pay-later');
		} else {
			$self.removeClass('blik-pay-later');
		}
		if (paymentCode === 25) {
			$self.addClass('blik-one-click');
		} else {
			$self.removeClass('blik-one-click');
		}
		if (!initial) {
			if (paymentCode === 16) {
				giftCardPaymentType.show();
				$('.js-payment-next', $self).addClass('btn-disabled');
			} else {
				if (!config.supplementPayment) {
					giftCardPaymentType.hide();
				}
				$('.js-payment-next', $self).removeClass('btn-disabled');
			}
		}
		addInfoAboutInstalment(paymentCode);
	}

	function addInfoAboutInstalment(paymentCode) {
		if (paymentCode == 5) {
			$instalmentWithAdvisorInfo.removeClass('none');
		} else {
			$instalmentWithAdvisorInfo.addClass('none');
		}
	}

	function updatePaymentTypeInCart(paymentCode) {
		if (!isSending) {
			selectPaymentType(paymentCode);
			sendNewPaymentType();
		}
	}

	function sendNewPaymentType() {
		var url = '/order-path-payment-select-payment-type.ltr';
		var data = config.supplementPayment ? { supplementPaymentTypeCode: config.supplementPaymentCode } : { paymentTypeCode: config.paymentCode };
		setSending(true);
		$.ajax({
			url: url,
			dataType: 'json',
			type: 'POST',
			data: data,
			success: function (json) {

				if (json && json.status) {
					if (json.status === 'OK') {
						//jest ok
					} else if (json.status === 'INVALID_STAGE' && json.message) {
						modal.alert(json.message)
					} else if (json.status === 'ORDER_ABSENCE') {
						loading.redirect("/cart.bhtml");
						return;
					} else if (json.status === 'FORBIDDEN_ACTION') {
						//nie można wykonać akcji
					}
				}
				setSending(false);
				refreshPreview();
				if (savedPaymentCode === 5) {
					refreshShopList();
				}
			},
			error: function () {
				setSending(false);
				modal.alert('Błąd przetwarzania rodzaju płatności');
			}
		});
	}
	function setSending(value) {
		if (value) {
			isSending = true;
			$self.addClass('is-sending');
			if (savedPaymentCode) {
				$paymentType.filter('[value=' + savedPaymentCode + ']').closest('.payment-item').addClass('loading');
			}
		} else {
			isSending = false;
			$self.removeClass('is-sending');
			if (savedPaymentCode) {
				$paymentType.filter('[value=' + savedPaymentCode + ']').closest('.payment-item').removeClass('loading');
			}
		}
	}
	function refreshPreview(callback) {
		setSending(true);
		$.ajax({
			url: '/order-path-preview.ltr',
			dataType: "json",
			data: {
				refresh: true
			},
			success: function (data) {
				setSending(false);
				if (callback) {
					callback();
				}
				callbackSuccess(data);
				broker.trigger('PREVIEW_REFRESH');
			},
			error: function () {
				modal.alert('Błąd odświeżenia stanu zamówienia po zmianie płatności. Strona zostanie odświeżona.', function () {
					loading.reload();
				});
			},
			complete: function () {
				setSending(false);
			}
		});
	}

	function setElements() {
		$self = $('#container');
		$paymentType = $('.js-payment-type', $self);
		$proforma = $('#transfer-payment-type');
		$shopsList = $('#shops-list', $self);
		$pesel = $('#pesel', $self);
		$permissions = $('#permissions', $self);
		$summary = $('.nav-buttons', $self);
		$cashTerm = $('#cash-on-delivery-payment', $self);
		$eTransferBanks = $('#e-transfer-banks .js-bank-select', $self);
		$bank = $('.js-selected-bank', $self);
		savedBank = $bank.val();
		$instalmentWithAdvisorInfo = $('.js-instalments-with-advisor-reminder', $self);
		config = orderConfig.getData();
		$eTransferShortBank = $('.payment-item-e_transfer');
	}

	function shortPaymentBanks($img) {
		$eTransferShortBank.addClass('short-banks');
		$eTransferShortBank.find('.show-banks img').remove();
		$eTransferShortBank.find('.show-banks').prepend($img.clone());
	}

	function setEvents() {
		$paymentType.on('click', function (event) {
			var paymentCode = parseInt($(this).val());
			if ((config.supplementPayment && paymentCode !== config.supplementPaymentCode) || (!config.supplementPayment && paymentCode !== config.paymentCode)) {
				if(config.loginRequired && config.loginRequired.includes(paymentCode)){
					$(this).closest('.payment-item').find('.guest-actions button').trigger('click');
					return false;
				}
				updatePaymentTypeInCart(paymentCode);
			}

		}).on('change', function (event) {
			console.log(111, event);
		})
		$eTransferBanks.on('click', function () {
			savePaymentBank(parseInt($(this).data('id')));
			shortPaymentBanks($(this).find('img'));
		});
		$('.js-show-banks', $self).on('click', function () {
			if(config.paymentCode != 3){
				$paymentType.filter('[value=3]').trigger('click');
			}
			$eTransferShortBank.removeClass('short-banks');
		});
	}
	function savePaymentBank(bankId) {
		if (bankId > 0) {
			if (!isSending) {
				savedBank = bankId;
				console.log('UPDATE PAYMENT BANK with bankId:' + bankId);
				$bank.val(bankId).valid();
				setSending(true);
				$eTransferBanks.removeClass('active').filter('[data-id=' + bankId + ']').addClass('active');
				$.ajax({
					url: '/order-path-payment-select-e-payment-bank.ltr',
					type: 'POST',
					dataType: 'json',
					data: {
						ePaymentBankId: bankId
					},
					success: function () {
						setSending(false);
						refreshPreview();
					},
					error: function () {
						setSending(false);
						modal.alert('Błąd wyboru banku. Proszę spróbować ponownie');
						refreshPreview();
					}
				});
			} else {
				console.log('Blokada wysyłania');
			}
		} else {
			modal.alert('Błąd zapisu banku');
		}
	}
	let isOneInit = false;
	function init(callback) {
		callbackSuccess = callback;
		setElements();
		setEvents();
		//eTransferBankList.init(showETransferRegulation);
		//previousPaymentOperator = eTransferBankList.operatorName();
		//instalmentBankList.init();
		if(!isOneInit){
			isOneInit = true;
			broker.on('SELECT_PAYMENT_TYPE', function(event, paymentType){
				$self.find('.guest-actions').remove();
				config.loginRequired = [];
				let $selected = $paymentType.filter('[value='+paymentType+']').first();
				$selected.prop('checked', true);
				updatePaymentTypeInCart(paymentType);
			});
		}
		if (config.paymentCode !== false) {
			selectPaymentType(config.supplementPayment ? config.supplementPaymentCode : config.paymentCode, true);
		}
	}
	function setDefault() {
		if ($paymentType && $paymentType.length) {
			$paymentType.prop('checked', false);
			selectPaymentType(false);
		}
	}
	return {
		init, sendNewPaymentType, setDefault
	};
});
